import { createAction, props } from '@ngrx/store';
import { IMonthlyIncomeResponse } from '../models/monthly-income.model';

export const loadMonthlyIncome = createAction('[MonthlyIncome] Load Monthly Income', props<{ request: { employeeId: string } }>());

export const loadMonthlyIncomeSuccess = createAction(
  '[MonthlyIncome] Load Monthly Income Success',
  props<{ response: IMonthlyIncomeResponse }>()
);

export const loadMonthlyIncomeFailure = createAction('[MonthlyIncome] Load Monthly Income Failure', props<{ error: Error | any }>());
